import React from "react";

export default function BottomMenu(props) {
  return (
    <div className="bottom-menu" style={{ zIndex: 1000 }}>
      <div
        className={`item-menu ${props.step === "a" && "item-menu-selected"}`}
        onClick={() => props.setStep("a")}
      >
        <i className="mdi mdi-security" style={{ fontSize: 30 }} />
        <a>Segurança</a>
      </div>

      <div
        className={`item-menu ${props.step === "b" && "item-menu-selected"}`}
        onClick={() => props.setStep("b")}
      >
        <i className="mdi mdi-human-male-child" style={{ fontSize: 30 }} />
        <a>Pais & Responsáveis</a>
      </div>

      <div
        className={`item-menu ${props.step === "c" && "item-menu-selected"}`}
        onClick={() => props.setStep("c")}
      >
        <i
          className="mdi mdi-frequently-asked-questions"
          style={{ fontSize: 30 }}
        />
        <a>FAQ</a>
      </div>
    </div>
  );
}
